<template>
  <div class="page-content">
    <div class="panel">
      <div class="left-panel">
        <!-- <div class="top-info">
          <span>帮助中心</span>
        </div> -->
        <div class="menu">
          <ul>
            <li :class="{ active: openType == 1 }">
              <p class="q-type-title" @click="clickChoicedHandle(1)">
                <router-link
                  :to="{ name: 'myQuestionTypeDetail', params: { type: 1 } }"
                >
                  常见问题
                </router-link>
              </p>
            </li>
            <li
              v-for="(t, index) in questionNames"
              v-if="t.helpCenterDetailsList && t.helpCenterDetailsList.length"
              :class="{ active: openType == t.type }"
            >
              <div
                v-if="index === 2 || index === 5"
                style="height:20px;width:100%; background:fff;"
              ></div>
              <p class="q-type-title" @click="clickChoicedHandle(t.type, t.helpCenterDetailsList)">
                <span
                  :style="openType == t.type ? { background: '#313131' } : ''"
                  style="width:5px;height:20px;background:#fff;display:inline-block;vertical-align: middle;margin-right:25px;margin-left:2px;margin-top: -4px;"
                ></span>
                {{ t.typeDisplay }}
                <i class="iconfont icon-dup" v-if="openType == t.type"></i>
                <i class="iconfont icon-arrow-up1" v-else></i>
              </p>
              <div class="q-names">
                <p v-for="q in t.helpCenterDetailsList">
                  <router-link
                    :to="{ name: 'myQuestionDetail', params: { code: q.code } }"
                  >
                    {{ q.name }}
                  </router-link>
                </p>
              </div>
              <div
                v-if="index === 1 || index === 4 || index === 7"
                style="height:20px;width:100%; background:fff;"
              ></div>
              <div
                v-if="index === 1 || index === 4 || index === 7"
                style="height:20px;width:100%; background:rgba(241,241,241,1);"
              ></div>
            </li>
          </ul>
        </div>
        <div
          v-if="isZhulogic"
          class="top-info top-info-specail"
          @click="clickChoicedHandle(-1)"
          :class="{ 'top-info-specail-active': openType === -1 }"
        >
          <router-link :to="{ name: 'myFeedback' }">
            <span>意见反馈</span>
          </router-link>
        </div>
      </div>
      <div class="right-panel  bg-fff">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<style scoped>
.page-content {
  width: 100%;
  overflow: hidden;
}

.panel {
  width: 1200px;
  margin: 40px auto;
  overflow: hidden;
}
.left-panel {
  width: 205px;
  float: left;
  background-color: #fff;
  border-radius: 4px;
}

.left-panel .menu {
  /* padding: 30px 0px; */
  padding-top: 25px;
}

.left-panel .top-info {
  height: 70px;
  line-height: 70px;
  text-align: center;
  border-bottom: 2px solid #f2f4f5;
}
.left-panel .top-info-specail a {
  display: inline-block;
  width: 100%;
  height: 100%;
  text-align: left;
  padding-left: 37px;
}
.left-panel .top-info-specail a:hover span{
    color:#e56a69;
}
.left-panel .top-info-specail a span {
  font-size: 14px;
  color: #707070;
}
.left-panel .top-info-specail-active a span {
  color: #e56a69;
}
.left-panel .top-info span {
  color: #313131;
  font-weight: 500;
  font-size: 20px;
}

.left-panel .top-info .avatar a {
  width: 100px;
  height: 100px;
  line-height: 100px;
  display: block;
  margin: 44px auto 30px;
  border-radius: 50%;
  overflow: hidden;
  background: #dce0e0;
  text-align: center;
}

.left-panel .top-info .info p {
  text-align: center;
  font-size: 14px;
  color: #6c6f70;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 90%;
  white-space: nowrap;
  margin: 0 auto;
  margin-bottom: 10px;
}

.left-panel .top-info .info .name {
  font-size: 16px;
  margin-bottom: 15px;
  color: #353838;
}

.left-panel .menu ul li .q-type-title {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #707070;
  text-align: left;
  cursor: pointer;
  position: relative;
}
.left-panel .menu ul li .q-type-title:hover {
  color: #e56a69;
}
.left-panel .menu ul li .q-type-title i {
  color: #313131;
  vertical-align: middle;
  font-size: 13px;
  /* display: inline-block;
  width: 0;
  height: 0;
  border-width: 5px;
  border-style: solid;
  position: absolute;
  right: 48px; */
}
.left-panel .menu ul li .q-type-title > a {
  font-size: 14px;
  color: inherit;
  display: block;
  padding-left: 37px;
}
.left-panel .menu ul li.active .q-type-title > a {
  color: #313131;
  font-weight: 500;
  font-size: 18px;
}
.left-panel .menu ul li.active .q-type-title {
  color: #313131;
  font-weight: 500;
  font-size: 18px;
}
.left-panel .menu ul li.active i.icon-drop-up {
  color: #313131;
}
.left-panel .menu ul li.active i.icon-arr-down {
  color: #313131;
}
.left-panel .menu ul li .q-names {
  display: none;
}
.left-panel .menu ul li .q-names p {
  line-height: 20px;
  padding: 10px 0;
  text-align: left;
  padding-left: 50px;
}
.left-panel .menu ul li .q-names a {
  font-size: 14px;
  display: block;
  color: #6c6f70;
}
.left-panel .menu ul li.active .q-names a:hover,
.left-panel .menu ul li.active .q-names a.router-link-active {
  color: #e56a69;
}
.left-panel .menu ul li.active .q-names {
  display: block;
}
.right-panel {
  width: 974px;
  margin-left: 20px;
  /*height: 86px;*/
  float: left;
  line-height: 88px;
  background: #fff;
}
.right-panel span {
  font-size: 16px;
  color: #353838;
}

.left-panel .avatar .img {
  width: 100%;
  height: 100%;
  background: no-repeat 50% / cover;
  background-origin: content-box;
}
</style>
<style>
.ql-editor {
  padding: 0;
}
</style>
<script>
import api from "../../../api";
import config from "../../../config/config";
export default {
  data() {
    return {
      wh: window.innerHeight - 64,
      imgBaseUrl: api.common.imgBaseUrl,
      isZhulogic: config.isZhulogic,
      questionNames: [],
      openType: undefined
    };
  },
  computed: {
    user() {
      return this.$store.state.user.info;
    }
  },
  methods: {
    clickChoicedHandle(target, helpCenterDetailsList) {
      if (target === 1) {
        this.openType = 1;
      } else if (target === -1) {
        this.openType = -1;
      } else {
        if (this.openType === target) {
          this.openType = undefined;
        } else {
          this.openType = target;
          if(!helpCenterDetailsList || helpCenterDetailsList.length === 0) return false;
          this.$router.push({name: 'myQuestionDetail', params: { code: helpCenterDetailsList[0].code }})
        }
      }
    },
    getQuestionNames() {
      api.questions
        .getQuestionNames({
          platform: "web",
          channel: this.isZhulogic ? "zhulogic" : "other"
        })
        .then(res => {
          this.questionNames = res.filter(type => {
            if (this.$route.params.code) {
              type.helpCenterDetailsList.forEach(name => {
                if (name.code == this.$route.params.code) {
                  this.openType = type.type;
                }
              });
            } else {
              if (window.location.href.split("/")[5] == "feedback") {
                this.openType = -1;
              } else {
                this.openType = this.$route.params.type || 1;
              }
            }
            return type.type !== 1;
          });
        });
    }
  },
  created() {
    this.getQuestionNames();
  }
};
</script>
